import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from 'src/app/core/services/auth.service';
import { AdapterService } from '../../../core/services/adapter.service';
import { UserService } from '../../../core/services/user.service';
import { LoginPromptModalComponent } from '../../modals/login-prompt-modal/login-prompt-modal.component';

@Component({
  selector: 'product-thumbnail',
  templateUrl: './product-thumbnail.component.html',
  styleUrls: ['./product-thumbnail.component.scss']
})
export class ProductThumbnailComponent implements OnInit {
  @Input() productDetail;
  @Input() view: number;
  @Input() isFromModal: boolean;
  @Output() onClickThumbnail = new EventEmitter<any>();
  @Output() refreshList = new EventEmitter<any>();
  @Input() isDiscontinued: boolean;
  @Input() isFromFavorites: boolean;  
  constructor(private _modalService: NgbModal,
    private _router: Router,
    private _adapterService : AdapterService,
    private readonly _authService: AuthService,
    private _userService: UserService) { }

  ngOnInit(): void {
  }

  clickThumbnail() {
    if (this.isFromModal)
      this.onClickThumbnail.emit(this.productDetail);
    else
      this._router.navigate([`/product`, this.productDetail.id])
  }

  toggleFavorite(event) {
    if (this.productDetail.isUserFavorite == true) {
      this._userService.removeUserFavorite({ productId: this.productDetail.id })
        .subscribe((response) => {
          if (response?.value?.isSuccessful) {
            this.productDetail.isUserFavorite = false;
            if (this.isFromFavorites) {
              this.refreshList.emit();
            }
          }
        });
    } else {
      this._userService.createUserFavorite({ productId: this.productDetail.id })
        .subscribe((response) => {
          if (response?.value?.isSuccessful) {
            this.productDetail.isUserFavorite = true;
            if (this.isFromFavorites) {
              this.refreshList.emit();
            }
          }
        });
    }
  }

  addToCart() {
    
  }

  quickOrder() {
    const loggedInUser = this._authService.getLoggedInUser();
    if (!loggedInUser || !loggedInUser?.userId) {
      const ngbModalOptions: any = {
        backdrop: true,
        keyboard: false,
        size: "lg"
      };
      const modalRef = this._modalService.open(LoginPromptModalComponent, ngbModalOptions);
      modalRef.result.then((response) => {
        if (response) {
          this._adapterService.setLocalStorageValue(`fotiou.selectedproduct`, { ...this.productDetail,quantity:1});
          this._router.navigate([`/orders/quick`])
        }
      });
    } else {
      this._adapterService.setLocalStorageValue(`fotiou.selectedproduct`, { ...this.productDetail,quantity:1});
      this._router.navigate([`/orders/quick`])
    }
  }

  quickOrder2() {
    const loggedInUser = this._authService.getLoggedInUser();
    if (!loggedInUser || !loggedInUser?.userId) {
      const ngbModalOptions: any = {
        backdrop: true,
        keyboard: false,
        size: "lg"
      };
      const modalRef = this._modalService.open(LoginPromptModalComponent, ngbModalOptions);
      modalRef.result.then((response) => {
        if (response) {
          let selectedProducts: any = [];
          selectedProducts.push({ ...this.productDetail, quantity: 1 });
          this._adapterService.setLocalStorageValue(`fotiou.selectedproduct`, selectedProducts);
          this._router.navigate([`/orders/quick`])
        }
      });
    } else {
      let selectedProducts: any = [];
      selectedProducts.push({ ...this.productDetail, quantity: 1 });
      this._adapterService.setLocalStorageValue(`fotiou.selectedproduct`, selectedProducts);
      this._router.navigate([`/orders/quick`])
    }
  }

}
